export const configAuth = () => {
  return {
    headers: {
      Authorization: `Bearer ${
        JSON.parse(localStorage.getItem("aedas_user") ?? "{}")?.token
      }`,
    },
  };
};
